import { Button, Stack, Typography } from "@mui/material";

export interface DayOption {
  key: string;
  title: string;
  subtitle?: string;
}

interface ScheduleDaySelectorProps {
  days: DayOption[];
  selectedKey?: string;
  onSelect: (key: string) => void;
  buttonWidth?: number;
  buttonHeight?: number;
}

export const ScheduleDaySelector = ({
  days,
  selectedKey,
  onSelect,
  buttonWidth = 140,
  buttonHeight = 120,
}: ScheduleDaySelectorProps) => {
  if (!days.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No bookings found.
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
      {days.map((day) => {
        const isSelected = selectedKey === day.key;
        return (
          <Button
            key={day.key}
            variant={isSelected ? "contained" : "outlined"}
            onClick={() => onSelect(day.key)}
            sx={{
              width: buttonWidth,
              height: buttonHeight,
              textTransform: "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2,
              px: 2,
              gap: 0.5,
              textAlign: "center",
            }}
          >
            <Typography variant="body1" fontWeight={600}>
              {day.title}
            </Typography>
            {day.subtitle && (
              <Typography variant="caption" color="text.secondary">
                {day.subtitle}
              </Typography>
            )}
          </Button>
        );
      })}
    </Stack>
  );
};

export default ScheduleDaySelector;
